import type { FC, FunctionComponent, SVGProps } from "react";
import styled from "styled-components";

import { UnstyledButton } from "../Button";

type IconProps = Readonly<{
    icon: FunctionComponent<SVGProps<SVGSVGElement>>;
    height: number;
    width: number;
    alt?: string;
    onClick?: () => void;
    withAnimation?: boolean;
    disabled?: boolean;
    color?: string;
}>;

export const Icon: FC<IconProps> = ({ icon, height, width, onClick, withAnimation, color, disabled = false }) => {
    const IconComponent = (
        <StyledIcon disabled={disabled} as={icon} height={height} width={width} withAnimation={withAnimation} color={color} />
    );

    return onClick && !disabled ? <UnstyledButton onClick={onClick}>{IconComponent}</UnstyledButton> : IconComponent;
};

const StyledIcon = styled.svg<Pick<IconProps, "withAnimation" | "disabled" | "color">>`
    transition: ${({ withAnimation, disabled }) => withAnimation && !disabled && "all .3s ease-in-out"};
    fill: ${({ color }) => color || "currentColor"};
    filter: ${({ disabled }) => (disabled ? "opacity(0.3)" : "none")};
    :hover {
        transform: ${({ withAnimation, disabled }) => withAnimation && !disabled && "scale(1.1)"};
    }
`;
